import { ArrowUp, Github, Instagram, Linkedin, Lock, Mail, MessageCircle } from "lucide-react";
import { EMAIL, NAV_LINKS, PHONE_DISPLAY, SOCIALS, WHATSAPP_LINK } from "@/data/content";
import { scrollToSection, scrollToTop } from "@/lib/scroll";

const SOCIAL_ICONS = { Github, Linkedin, Instagram };

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden border-t border-[#1A1A20] bg-[#0A0A0C]">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-10 left-1/2 -translate-x-1/2 select-none whitespace-nowrap font-display text-[22vw] font-extrabold leading-none tracking-tighter text-[#F4F4F6]/[0.025]"
      >
        LUIZ.DEV
      </span>
      <div className="relative mx-auto max-w-7xl px-4 pb-10 pt-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <span className="font-display text-2xl font-extrabold tracking-tight text-zinc-100">
              LUIZ<span className="text-[#E50914]">.DEV</span>
            </span>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-zinc-500">
              Sites de alto impacto para empresas que precisam de autoridade e para estúdios de jogos que
              precisam de imersão. Código limpo, velocidade extrema, design que converte.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((social) => {
                const Icon = SOCIAL_ICONS[social.icon];
                return (
                  <a
                    key={social.name}
                    data-testid={`footer-${social.testid}`}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.name}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-[#2A2A33] text-zinc-500 transition-all duration-300 hover:-translate-y-1 hover:border-[#E50914] hover:text-[#E50914]"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono-code text-[10px] uppercase tracking-[0.3em] text-zinc-500">Navegação</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    data-testid={`footer-${link.testid}`}
                    onClick={() => scrollToSection(link.id)}
                    className="link-underline text-sm text-zinc-400 transition-colors hover:text-zinc-100"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-mono-code text-[10px] uppercase tracking-[0.3em] text-zinc-500">Contato direto</h4>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  data-testid="footer-whatsapp"
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center gap-3 text-sm text-zinc-400 transition-colors hover:text-zinc-100"
                >
                  <MessageCircle className="h-4 w-4 text-[#E50914]" />
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${EMAIL}`}
                  className="group flex items-center gap-3 break-all text-sm text-zinc-400 transition-colors hover:text-zinc-100"
                >
                  <Mail className="h-4 w-4 shrink-0 text-[#E50914]" />
                  {EMAIL}
                </a>
              </li>
            </ul>
            <div
              data-testid="footer-security-badge"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#22222A] bg-[#101014] px-3.5 py-1.5"
            >
              <Lock className="h-3 w-3 text-emerald-400" />
              <span className="font-mono-code text-[10px] uppercase tracking-widest text-zinc-500">
                Conexão segura · Dados protegidos
              </span>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-6 border-t border-[#1A1A20] pt-8 sm:flex-row">
          <p className="text-center font-mono-code text-xs text-zinc-600 sm:text-left">
            © 2026 Luiz Henrique — Desenvolvedor Web. Todos os direitos reservados.
          </p>
          <button
            data-testid="back-to-top-btn"
            onClick={scrollToTop}
            className="group flex items-center gap-3 font-mono-code text-[10px] uppercase tracking-[0.3em] text-zinc-500 transition-colors hover:text-zinc-100"
            aria-label="Voltar ao topo"
          >
            Voltar ao topo
            <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#2A2A33] transition-all duration-300 group-hover:-translate-y-1 group-hover:border-[#E50914] group-hover:text-[#E50914]">
              <ArrowUp className="h-4 w-4" />
            </span>
          </button>
        </div>
      </div>
    </footer>
  );
};
